import * as Actions from '../../../Modules/CmsActions'
import type { IDynamicPage } from '../../../Types/UI'

const initialState: IDynamicPage = {
  loading: false,
  saving: false,
  edit: {
    id: 0,
    name: '',
    post_type_id: 0,
    seo_settings: [],
    is_used_embed_script_tag: false,
    is_used_seo_tag: false,
    is_used_seo_tag_v2: false,
    is_used_favicon_tag: false,
    type: 'post_type_list',
    post_type_category: 'admin',
    templateTypeKey: 'blog',
    color_set_id: 0,
    en_font_family_id: 0,
    ja_font_family_id: 0,
    shape_mode: 0,
    hasOriginalSection: false,
    colors: [],
    shapes: [],
    jaFont: [],
    enFont: [],
    created_at: '',
    updated_at: '',
  },
  list: [],
}

const UIDynamicPageReducer = (state: IDynamicPage = initialState, action) => {
  switch (action.type) {
    case Actions.REQUEST_FETCH_ALL_DYNAMIC_PAGE:
    case Actions.REQUEST_FETCH_DYNAMIC_PAGE:
      return loading(state)

    case Actions.REQUEST_UPDATE_DYNAMIC_PAGE:
      return saving(state)

    case Actions.FINISH_FETCH_ALL_DYNAMIC_PAGE:
      return updateList(state, action.payload)

    case Actions.FINISH_FETCH_DYNAMIC_PAGE:
      return updateEditInfoWithLoaded(state, action.payload.dynamicPage)

    case Actions.FINISH_UPDATE_DYNAMIC_PAGE:
      return saved(state)

    case Actions.UNLOAD_DYNAMIC_PAGE:
      return { ...state, edit: initialState.edit }

    case Actions.FAILURE_FETCH_ALL_DYNAMIC_PAGE:
    case Actions.FAILURE_FETCH_DYNAMIC_PAGE:
    case Actions.FAILURE_UPDATE_DYNAMIC_PAGE:
      return { ...state, loading: false, saving: false }

    default:
      return state
  }
}

const loading = (state: IDynamicPage) => {
  return { ...state, loading: true }
}

const saving = (state: IDynamicPage) => {
  return { ...state, saving: true }
}

const saved = (state: IDynamicPage) => {
  return { ...state, saving: false, success: true }
}

const updateList = (state: IDynamicPage, payload) => {
  return { ...state, loading: false, list: payload.dynamicPages }
}

const updateEditInfoWithLoaded = (state: IDynamicPage, dynamic_page) => {
  return {
    ...state,
    loading: false,
    edit: {
      ...initialState.edit,
      ...dynamic_page,
      seo_settings: dynamic_page.seo_settings || initialState.edit.seo_settings,
    },
  }
}

export default UIDynamicPageReducer
